import React from "react";
import { Box, Heading } from "@chakra-ui/react";
import { NextSeo } from "next-seo";

import HeaderMenu from "@/components/HeaderMenu";
import Footer from "@/components/Footer";
import { MarkdownRender } from "../MarkdownRender";

function ContentPage(props: any) {
  return (
    <>
      <HeaderMenu cookies={props.cookies.data} menu={props.header[0].items} submenu={props.navbar.data?.attributes.submenu_header} />
      <NextSeo
        title={props.page.data[0].attributes.metaTitle}
        description={props.page.data[0].attributes.metaDescription}
        canonical={props.page.data[0].attributes.canonicalURL}
      />
      <Box
        maxWidth="1120px"
        margin="0 auto"
        width="90%"
        mb="32px"
        as="header"
        pt={{ base: "40px", lg: "60px" }}
        pb={{ base: "60px", lg: "80px" }}
      >
        <Heading
          mb={{ base: "20px", lg: "40px" }}
          as="h1"
          fontWeight="800"
          paddingLeft="32px"
        >
          {props.page.data[0].attributes.title}
        </Heading>
        <Box
          bgColor="#fff"
          as="article"
          maxWidth="100%"
          overflow="hidden"
          boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);"
          borderRadius="8px"
        >
          <Box className="article" padding="32px 32px 24px 32px">
            <MarkdownRender>
              {props.page.data[0].attributes.content!}
            </MarkdownRender>
          </Box>
        </Box>
      </Box>
      <Footer menu={props.footer[0].items} />
    </>
  );
}

export default ContentPage;
